import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LectureStatusEnum } from 'src/app/submit-lecture/lecture.values';

@Component({
  selector: 'status-cell',
  templateUrl: './status-cell.component.html',
  styleUrls: ['./status-cell.component.scss'],
})
export class StatusCellComponent implements ICellRendererAngularComp {

  refresh;
  status: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.status = this.params.data?.status;
  }

}
